import { Row } from 'antd';
import classNames from 'classnames';

import ErrorBoundary from '../components/ErrorBoundary';
import { LinksRow } from '../components/nav/navElements';
import { externalLinks } from '../config/externalLinks';
import { useFooterStyles } from './Footer.styles';

export const FooterTheme = {
  DARK: 'DARK',
  LIGHT: 'LIGHT',
};

export default function Footer({ theme }) {
  const { styles } = useFooterStyles();
  return (
    <ErrorBoundary>
      <Row
        className={classNames(styles.footer, {
          [styles.footerDark]: theme === FooterTheme.DARK,
          [styles.footerLight]: theme === FooterTheme.LIGHT,
        })}
        type="flex"
        align="middle"
        justify="center"
      >
        <LinksRow
          links={[
            { href: externalLinks.privacyPolicy, textId: 'footer.privacy' },
            {
              href: externalLinks.conditionsOfCarriage,
              textId: 'footer.conditions',
            },
            { href: externalLinks.contact, textId: 'header.contactUs' },
          ]}
        />
      </Row>
    </ErrorBoundary>
  );
}
